module.exports = __webpack_public_path__ + "static/media/rockGlass.6193f3c0.svg";